<template>
  <div class="dialogEditAddApiClient">
    <el-dialog :visible.sync="dialog" @close="close">
      <el-form v-loading="loadingPage" v-if="dialog" :model="ruleForm" ref="ruleForm" :rules="rules" @submit.prevent v-on:submit.prevent>
        <el-row :gutter="20">
          <el-col :sm="24" :md="12">
            <el-form-item prop="name" label="Nome" :error="error.name">
              <el-input :disabled="isEdit" size="large" v-model="ruleForm.name" required></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12">
            <el-form-item prop="email" label="E-mail" :error="error.email">
              <el-input :disabled="isEdit" size="large" v-model="ruleForm.email" required></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item v-if="!isEdit" prop="password" label="Senha" :error="error.password">
          <el-input  size="large"
                     placeholder="● ● ● ● ● ●"
                     v-model="ruleForm.password"
                     :type="type" required>
            <i class="el-icon-view el-input__icon" slot="suffix" @click="changeType">
            </i>
          </el-input>
        </el-form-item>
        <el-form-item prop="type" label="Tipo" :error="error.type">
          <el-select v-model="ruleForm.type" style="width: 100%">
            <el-option label="Desenvolvimento" value="develop" />
            <el-option label="Produção" value="production" />
          </el-select>
        </el-form-item>
        <el-form-item prop="marketplace_manager_id" label="Marketplace">
          <SelectSearchGerenteMarketplace :disabled="isEdit" :model="ruleForm.marketplace_manager_id" :isEdit="isEdit" @handleValue="(x) => {$set(ruleForm, 'marketplace_manager_id', x)}" />
        </el-form-item>
        <el-form-item prop="description" label="Descrição" :error="error.description">
          <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4}"
              v-model="ruleForm.description">
          </el-input>
        </el-form-item>
        <div v-if="ruleForm.token_jwt" style="text-align: center">
          <label for="description" class="el-form-item__label">Token</label>
          <el-alert
              :closable="false"
              :title="ruleForm.token_jwt"
              type="info">
          </el-alert>

          <el-button @click.prevent="openGenrateToken">Gerar Novo Token</el-button>
        </div>
      </el-form>
      <span slot="footer" style="display: flex; align-items: center; justify-content: space-between;">
        <el-button v-if="ruleForm.id" @click.prevent="delFinancial">Excluir</el-button>
        <div v-else></div>
        <el-button type="primary" native-type="submit" @click.prevent="submitForm('ruleForm')">Salvar</el-button>
      </span>
    </el-dialog>
    <el-dialog
        title="Gerar outro Token"
        :visible.sync="dialogVisibleGene"
        width="30%">
      <div>
        <el-form v-loading="loadingPage" v-if="dialogVisibleGene" :model="ruleFormGene" ref="ruleForm" :rules="rules" @submit.prevent v-on:submit.prevent>
          <el-form-item prop="email" label="E-mail" :error="error.email">
            <el-input size="large" v-model="ruleFormGene.email" required></el-input>
          </el-form-item>
          <el-form-item prop="password" label="Senha" :error="error.password">
            <el-input  size="large"
                       placeholder="● ● ● ● ● ●"
                       v-model="ruleFormGene.password"
                       :type="type" required>
              <i class="el-icon-view el-input__icon" slot="suffix" @click="changeType">
              </i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="generateToken">Gerar</el-button>
      </span>
    </el-dialog>
    <el-dialog
        title="Token"
        :visible.sync="dialogVisible"
        width="30%">
      <div style="background: #dadada; padding: 15px;overflow-wrap: break-word; word-wrap: break-word; word-break: break-word;">
        {{tokenJwt}}
      </div>
      <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false">Ok</el-button>
          </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  deleteApiClient,
  getApiClient,
  postApiClient,
  postGenerateTokenApiClient,
  putApiClient,
} from "@/app/domains/Config/services";
import {clearRuleForm, makeErrorFilds} from "@/app/plugins/utils";
import SelectSearchGerenteMarketplace from "@/app/components/GerenteMarketplace/SelectSearchGerenteMarketplace";
import {mapGetters} from "vuex";

export default {
  name: "dialogEditAddApiClient",
  components: {
    SelectSearchGerenteMarketplace,
  },
  props: ['show', 'idConta'],
  watch: {
    'show': function (e) {
      this.dialog = e
    },
    'idConta': function (e) {
      if (e !== '') {
        
        this.getMCC(e)
      }
    }
  },
  computed: {
    ...mapGetters('Auth', ['currentUser']),
    isEdit: function () {
      return !!(this.ruleForm.id)
    }
  },
  data () {
    return {
      dialogVisible: false,
      dialogVisibleGene: false,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      type: 'password',
      dialog: false,
      loadingPage: false,
      error: {},
      rules: {},
      ruleForm: {},
      ruleFormGene: {},
      tokenJwt: '',
    }
  },
  methods: {
    changeType (ev) {
      if (this.type === 'password') {
        this.type = 'text'
      } else if (this.type === 'text') {
        this.type = 'password'
      }
    },
    generateToken() {
      this.$confirm('Deseja gerar outro token?', 'Atenção', {
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        center: true,
        type: 'warning'
      }).then( async () => {
        try {
          let response;
          // let query = this.$route.meta.pathAPI + '/' + this.ruleForm.id
          this.ruleForm.token_jwt = ''
          response = await postGenerateTokenApiClient({id: this.ruleForm.id, data: this.ruleFormGene})
          this.ruleForm.token_jwt = response.data.token_jwt
          this.$message({
            showClose: true,
            message: 'Token Gerado',
            type: 'success'
          })
          this.dialogVisibleGene = false
        } catch (e) {
          this.error = makeErrorFilds(e)
          this.$message({
            showClose: true,
            message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
            type: 'error'
          })
        } finally {
          this.loadingPage = false
        }
      }).catch(() => {});
    },
    openGenrateToken() {
      this.dialogVisibleGene = true
    },
    close() {
      this.$emit('close')
      this.$refs['ruleForm'].resetFields()
      this.$refs['ruleForm'].clearValidate()
      this.ruleForm = {}
    },
    delFinancial () {
      this.$confirm('Deseja excluir?', 'Atenção', {
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        center: true,
        type: 'warning'
      }).then( async () => {
        this.loadingPage = true
        this.error = {}
        try {
          let response;
          // let query = this.$route.meta.pathAPI + '/' + this.ruleForm.id
          response = await deleteApiClient('/'+this.ruleForm.id)
          this.$message({
            showClose: true,
            message: response.message,
            type: 'success'
          })
          this.dialog = false
          this.close()
        } catch (e) {
          this.error = makeErrorFilds(e)
          this.$message({
            showClose: true,
            message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
            type: 'error'
          })
        } finally {
          this.loadingPage = false
        }
      }).catch(() => {});
    },
    submitForm (ruleForm) {
      this.$refs['ruleForm'].validate(async (valid) => {
        if (valid) {
          this.error = {}
          this.loadingPage = true
          try {
            if (this.ruleForm.id !== undefined) {
              await putApiClient(clearRuleForm({id: this.ruleForm.id, type: this.ruleForm.type, description: this.ruleForm.description}))
              this.$message({
                showClose: true,
                message: 'Registro Alterado com sucesso!',
                type: 'success'
              })
            } else {
              let response = await postApiClient(this.ruleForm)
              
              this.tokenJwt = response.data.token_jwt
              this.dialogVisible = true
              this.$message({
                showClose: true,
                message: 'Adicionado com sucesso',
                type: 'success'
              })
            }
            this.dialog = false
            this.close()
          } catch (e) {
            this.error = makeErrorFilds(e)
            this.$message({
              showClose: true,
              message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
              type: 'error'
            })
          } finally {
            this.loadingPage = false
          }
        }
      })
    },
    handleAction () {},
    async getMCC (id) {
      this.loadingPage = true
      try {
        let response = await getApiClient('/'+id)
        this.ruleForm = response.data
        this.$set(this.ruleForm, 'name', response.data.user.name)
        this.$set(this.ruleForm, 'email', response.data.user.email)
        this.$set(this.ruleForm, 'marketplace_manager_id', response.data.user.marketplace_manager_id)
        this.$set(this.ruleForm, 'marketplace_id', response.data.user.marketplace_id)
        this.$set(this.ruleForm, 'token_jwt', response.data.token_jwt)
        
      } catch (e) {
        this.$message({
          showClose: true,
          message: 'Erro ao carregar.',
          type: 'error'
        })
      } finally {
        this.loadingPage = false
      }
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
